const defaultRender = (value) => (value ? value : '--');

const columns = [
  {
      title: "User",
      dataIndex: "userDetails",
      render: (value) => (value ? value : "--"),
    },
  {
    title: "Activity",
    dataIndex: "activity",
    render: defaultRender,
  },
  {
    title: "Message",
    dataIndex: "message",
    render: defaultRender,
  },
  {
    title: "Created Date",
    dataIndex: "created_at",
    render: defaultRender,
  },
];

export default columns;
